import React, { Component } from 'react';
import { hashHistory } from 'react-router';
import {protocolCode } from '../../../BankCode'
export default class PayWarmTips extends Component {
  ProtocolPaper(name){
    let code=protocolCode[name];
    console.log(hashHistory)
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  render(){
    if (this.props.hqt) {
      return (
        <footer className='superFooter'>
          <p style={{height:30}}>特别提示 :</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>1、活期通是由华夏基金提供的理财产品，华夏查理智投仅可进行活期通充值，如需办理活期通赎回、交易查询等业务请登录华夏基金管家；</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>2、15:00点前完成支付，预计在下一交易日开始享受收益</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>3、预计第三个交易日可查询收益；</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>4、交易日15:00后或非交易日提交申请，按下一交易日的申请处理；</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>5、基金净值会因证券市场波动等因素波动，可能导致损失；</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>6、管理人投资判断会有差异从而影响基金的收益水平，可能发生损失；</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>7、瑞管理人业务或财务状况发生变化，可能影响投资者判断，也可能导致损失。</p>
          <div style={{fontSize:'0.24rem',display: "-webkit-flex"}}>
           { 
             this.props.buyType=='SF'?
             null
             :
           <p style={{color:'#5b6370',lineHeight:'22px'}}>如需了解更多请阅读</p>
           }
            {
              this.props.buyType=='SF'?
              null
              // <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('华夏查理智投投资者风险告知函')}>《华夏查理智投投资者风险告知函》</p>
              :
              <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('投资者风险告知函')}>《投资者风险告知函》</p>

            }
          </div>
        </footer>
      );   
    }else{
      return (
        <footer className='superFooter'>
          <p style={{height:30}}>特别提示 :</p>
          {/* <p style={{color:'#5b6370',lineHeight:'22px',fontWeight:"bold"}}>1、本业务暂不支持撤单。</p> */}
          <p style={{color:'#5b6370',lineHeight:'22px',fontWeight:"bold"}}>1、基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>2、基金净值会因证券市场波动等因素波动，可能导致损失。 </p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>3、管理人投资判断会有差异从而影响基金的收益水平，可能发生损失。</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>4、若管理人业务或财务状况变化，可能影响投资者判断，也可能导致损失。</p>
          <p style={{color:'#5b6370',lineHeight:'22px'}}>5、投资者可以通过录音、截屏等方式留存基金投资顾问服务的相关信息。</p>
          
          {
            this.props.fundLimit==='002552'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金每半年开放一次申购和赎回</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、若错过某一开放期而未能赎回，其份额将转入下一封闭期，至下一开放期方可赎回</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、在开放期的最后一日日终，满足一定的情形时，基金与其他基金合并或终止基金合同，基金份额持有人面临一定的基金清算风险</p>]:null
          }
          {
            this.props.fundLimit==='003697'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金每6个月开放一次申购和赎回</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、若错过某一开放期而未能赎回，其份额将转入下一封闭期，至下一开放期方可赎回</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、在开放期的最后一日日终，满足一定的情形时，基金与其他基金合并或终止基金合同，基金份额持有人面临一定的基金清算风险</p>]:null
          }
          {
            this.props.fundLimit==='004063'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金每1年开放一次申购和赎回</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、若错过某一开放期而未能赎回，其份额将转入下一封闭期，至下一开放期方可赎回</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、在开放期的最后一日日终，满足一定的情形时，基金可转为普通开放式基金</p>]:null
          }
          {
            this.props.fundLimit==='160323'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金每18个开放一次申购和赎回</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、若错过某一开放期而未能赎回，其份额将转入下一封闭期，至下一开放期方可赎回</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、在开放期的最后一日日终，满足一定的情形时，基金可转为普通开放式基金，不再以定期开放的方式运作</p>]:null
          }
          {
            this.props.fundLimit==='160324'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金每18个开放一次申购和赎回</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、若错过某一开放期而未能赎回，其份额将转入下一封闭期，至下一开放期方可赎回</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、在开放期的最后一日日终，满足一定的情形时，基金可转为普通开放式基金，不再以定期开放的方式运作</p>]:null
          }
          {
            this.props.fundLimit==='001057'||this.props.fundLimit==='001058'?
            [<p  key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金产品因经营立构的业务或者财产状况变化，可能导致本金或者原始本金亏损；</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、基金产品因经营立构的业务或者财产状况变化，会影响客户判断；</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、理财30天只能在购买一个月后的对日发起赎回，如遇节假日顺延。</p>]:null
          }
          {
            this.props.fundLimit==='501186'?
            [<p key='a' style={{color:'#5b6370',lineHeight:'22px'}}>4、基金成立之日起3年内封闭运作并上市，在此期间每6个月受限开放一次，只开放申购，不开放赎回；</p>,
             <p key='b' style={{color:'#5b6370',lineHeight:'22px'}}>5、本基金在封闭运作期的受限开放期内暂时只接受场外申购，不接受场内申购。在条件允许的情况下，本基金将在受限开放期内开放场内申购；</p>,
             <p key='c' style={{color:'#5b6370',lineHeight:'22px'}}>6、本基金自成立6个月后上市交易，届时投资者可将份额转场内上市交易；</p>,
             <p key='d' style={{color:'#5b6370',lineHeight:'22px'}}>7、本基金封闭运作3年届满后，将转型为普通上市型开放式基金（LOF）。</p>]:null
          }
          <div style={{fontSize:'0.24rem',display: "-webkit-flex"}}>
          { 
             this.props.buyType=='SF'?
             null
             :
           <p style={{color:'#5b6370',lineHeight:'22px'}}>如需了解更多请阅读</p>
           }
            {
              this.props.buyType=='SF'?
              null
              // <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('华夏查理智投投资者风险告知函')}>《华夏查理智投投资者风险告知函》</p>
              :
              <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('投资者风险告知函')}>《投资者风险告知函》</p>

            }
          </div>
        </footer>
      );
       
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/PayWarmTips.js